export const SEVERITY_META = {
  critical: { label: "Kritické zjištění", dot: "bg-red-600", text: "text-red-800", bg: "bg-red-50", border: "border-red-200", emoji: "🔴" },
  high: { label: "Závažné zjištění", dot: "bg-orange-600", text: "text-orange-800", bg: "bg-orange-50", border: "border-orange-200", emoji: "🟠" },
  medium: { label: "Středně závažné", dot: "bg-amber-500", text: "text-amber-800", bg: "bg-amber-50", border: "border-amber-200", emoji: "🟡" },
  unverifiable: { label: "Neověřitelné", dot: "bg-slate-400", text: "text-slate-700", bg: "bg-slate-50", border: "border-slate-200", emoji: "⚪" },
  ok: { label: "Splněno", dot: "bg-emerald-600", text: "text-emerald-800", bg: "bg-emerald-50", border: "border-emerald-200", emoji: "🟢" },
};

export function bucketOf(f) {
  if (f.status === "NEOVERITELNE") return "unverifiable";
  if (f.status === "SPLNENO" || f.status === "NERELEVANTNI") return "ok";
  if (f.severity >= 9) return "critical";
  if (f.severity >= 7) return "high";
  return "medium";
}

export const STATUS_LABELS = {
  SPLNENO: "Splněno", CASTECNE: "Částečně splněno", NESPLNENO: "Nesplněno",
  NEOVERITELNE: "Neověřitelné", NERELEVANTNI: "Nerelevantní",
};

export const COVERAGE_META = {
  EXPLICIT: { label: "Explicitně pokryto", cls: "bg-emerald-100 text-emerald-900" },
  IMPLICIT: { label: "Implicitně přítomno", cls: "bg-sky-100 text-sky-900" },
  PARTIAL: { label: "Částečné pokrytí", cls: "bg-yellow-100 text-yellow-900" },
  NOT_FOUND: { label: "Nenalezeno", cls: "bg-red-100 text-red-900" },
  UNVERIFIABLE: { label: "Neověřitelné", cls: "bg-slate-100 text-slate-700" },
};

export const SeverityBadge = ({ finding }) => {
  const m = SEVERITY_META[bucketOf(finding)];
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold ${m.bg} ${m.text} border ${m.border}`}
      data-testid="severity-badge">
      <span className={`h-2 w-2 rounded-full ${m.dot}`} />
      {m.label} · {finding.severity}/10
    </span>
  );
};

export const StatusBadge = ({ status }) => (
  <span className="inline-flex items-center rounded-full bg-slate-100 px-2.5 py-0.5 text-xs font-medium text-slate-700 border border-slate-200">
    {STATUS_LABELS[status] || status}
  </span>
);

export const confidenceLabel = (v) =>
  v >= 0.85
    ? { label: "Vysoká", note: "AI měla k dispozici jednoznačné podklady v dokumentu.", cls: "bg-emerald-100 text-emerald-800" }
    : v >= 0.6
      ? { label: "Střední", note: "Podklady v dokumentu byly jen částečné — doporučujeme lidské potvrzení.", cls: "bg-amber-100 text-amber-800" }
      : { label: "Nízká", note: "AI si vyhodnocením není jistá — zjištění ověřte lidsky.", cls: "bg-rose-100 text-rose-800" };

export const ConfidenceBar = ({ value }) => (
  <div className="flex items-center gap-2">
    <div className="h-1.5 w-24 rounded-full bg-slate-200 overflow-hidden">
      <div className="h-full rounded-full bg-emerald-600 transition-[width]" style={{ width: `${Math.round(value * 100)}%` }} />
    </div>
    <span className="text-xs font-medium text-slate-600">{Math.round(value * 100)} %</span>
  </div>
);
